import type { DossierDTO } from '@/features/api/extranet/dto/Dossier/Synthese'
import type { LovDossierDTO } from '@/features/api/extranet/dto/Dossier/Synthese/LovDossierDTO'
import * as services from '@/features/services/detail/dossier/DossierService'
import { defineStore } from 'pinia'
import { shallowRef } from 'vue'

export const useDossierTTStore = defineStore('dossierTt', () => {
  const model = shallowRef<DossierDTO>()
  const lov = shallowRef<LovDossierDTO>()

  async function loadData(code: string) {
    lov.value = await services.loadDossierOutilFpeLov()
    model.value = await services.loadDossierOutilFpe(code)
  }

  function $reset() {
    model.value = undefined
    lov.value = undefined
  }

  return {
    lov,
    model,
    loadData,
    $reset
  }
})
